import { Injectable } from '@angular/core';

import { ProjectMemberRole } from 'src/app/constants';
import { ListRequest, ListResponse, ServiceAccount } from 'src/models';
import { Project, ProjectMember } from 'src/models/projects';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService extends GenericObjectsService<Project> {
  protected baseUrl = '/projects';

  listForUser(userId: string, options: ListRequest = {}): Promise<ListResponse<Partial<ProjectMember>>> {
    return this.apiService.postPromise(`/users/${userId}/projects/list`, options);
  }

  listMembers(projectId: string, options: ListRequest = {}): Promise<ListResponse<Partial<ProjectMember>>> {
    return this.apiService.postPromise(`/projects/${projectId}/members/list`, options);
  }

  updateMember(projectId: string, userId: string, data: Partial<ProjectMember>): Promise<ProjectMember> {
    return this.apiService.patchPromise(`/projects/${projectId}/members/${userId}`, data);
  }

  addMember(
    projectId: string,
    data: Partial<ProjectMember>,
    sendWelcomeEmail: boolean = false,
  ): Promise<ProjectMember> {
    return this.apiService.postPromise(`/projects/${projectId}/members`, { ...data, sendWelcomeEmail });
  }

  removeMember(projectId: string, userId: string): Promise<void> {
    return this.apiService.deletePromise(`/projects/${projectId}/members/${userId}`);
  }

  createServiceAccount(projectId: string, data: { name: string; role: ProjectMemberRole }): Promise<ServiceAccount> {
    return this.apiService.postPromise(`/projects/${projectId}/service-accounts`, data);
  }

  updateCustomFields(projectId: string, data: { fields: any[] }): Promise<Project> {
    return this.apiService.patchPromise(`/projects/${projectId}/custom-fields`, data);
  }
}
